import { GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH } from 'nav-meta/constants';
export const hsLogoContainerMaxWidth = verticalNavWidth => {
  const HEADER_PADDING = 12;
  const DEFAULT_COLLAPSED_WIDTH = parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH, 10);

  // For some views, vertical nav is removed and max-width is set to "auto" without this condition
  // and setting max-width to "auto" is like setting it to "none" which essentially removes the max with constraint
  // and the logo container becomes very wide
  if (!verticalNavWidth) {
    return `${DEFAULT_COLLAPSED_WIDTH - HEADER_PADDING}px`;
  }
  if (verticalNavWidth >= DEFAULT_COLLAPSED_WIDTH) {
    return `${verticalNavWidth - HEADER_PADDING}px`;
  }
  return 'auto';
};